import { MessageCircle, ArrowRight } from "lucide-react";
import { getWhatsAppUrl } from "@/lib/whatsapp";
import { trackEvent, EVENTS } from "@/lib/tracking";
import { scrollToId } from "@/lib/scroll";

/**
 * WhatsAppButton — tombol CTA WhatsApp (hijau) yang dipakai ulang.
 * source: dari mana klik berasal (untuk analytics).
 */
export const WhatsAppButton = ({
  message,
  label,
  source = "generic",
  className = "",
  testId = "whatsapp-cta",
  size = "md",
}) => {
  const sizeCls =
    size === "lg" ? "px-8 py-4 text-base" : size === "sm" ? "px-4 py-2.5 text-sm" : "px-6 py-3.5 text-[15px]";
  return (
    <a
      href={getWhatsAppUrl(message)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackEvent(EVENTS.WHATSAPP_CLICK, { source })}
      data-testid={testId}
      className={`group inline-flex items-center justify-center gap-2.5 rounded-lg bg-[#25D366] font-bold text-white transition-colors duration-200 hover:bg-[#1eb85a] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#25D366] focus-visible:ring-offset-2 ${sizeCls} ${className}`}
    >
      <MessageCircle className="h-5 w-5" aria-hidden="true" />
      {label}
    </a>
  );
};

/**
 * QuoteButton — CTA "Minta Survey & Penawaran" (dark) scroll ke lead form.
 */
export const QuoteButton = ({
  label,
  source = "generic",
  className = "",
  testId = "quote-cta",
  size = "md",
  variant = "dark",
}) => {
  const sizeCls =
    size === "lg" ? "px-8 py-4 text-base" : size === "sm" ? "px-4 py-2.5 text-sm" : "px-6 py-3.5 text-[15px]";
  const variantCls =
    variant === "dark"
      ? "bg-[#0F172A] text-white hover:bg-[#1E293B]"
      : variant === "outline"
        ? "bg-transparent text-slate-900 ring-1 ring-inset ring-slate-300 hover:bg-slate-50"
        : "bg-white text-[#0F172A] hover:bg-slate-100";
  return (
    <button
      type="button"
      onClick={() => {
        trackEvent(EVENTS.REQUEST_QUOTE, { source });
        scrollToId("lead-form");
      }}
      data-testid={testId}
      className={`group inline-flex items-center justify-center gap-2.5 rounded-lg font-bold transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 focus-visible:ring-offset-2 ${sizeCls} ${variantCls} ${className}`}
    >
      {label}
      <ArrowRight className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" />
    </button>
  );
};

export default WhatsAppButton;
